/* Source: DEV-485 polish pass v1 | 2026-10-15 | card photos fade in as they finish loading.
   Progressive: if this file never runs, every image shows exactly as before. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;
  var SEL = '.card-gallery img:not(.card-gallery__hover-image)';
  function arrive(img) {
    if (img.classList.contains('is-arrived')) return;
    if (img.complete && img.naturalWidth > 0) { img.classList.add('is-arrived'); return; }
    var done = function () { img.classList.add('is-arrived'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    setTimeout(done, 4000);
  }
  function scan(scope) { var l = (scope || document).querySelectorAll(SEL); for (var i = 0; i < l.length; i++) arrive(l[i]); }
  root.classList.add('pr-fade');
  scan();
  document.addEventListener('DOMContentLoaded', function () { scan(); });
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) for (var j = 0; j < list[i].addedNodes.length; j++) {
      var n = list[i].addedNodes[j];
      if (n.nodeType === 1) { if (n.matches && n.matches(SEL)) arrive(n); else if (n.querySelectorAll) scan(n); }
    }
  }).observe(root, { childList: true, subtree: true });
})();
